// Generated with util/create-component.js
import AutoComplete from './AutoComplete';

export default AutoComplete;
